export const EnhancementViewLevel = {
  DEPARTMENT: 'Department',
  TEAM: 'Team',
  EMPLOYEE: 'Employee'
} as const

export type EnhancementViewLevel = typeof EnhancementViewLevel[keyof typeof EnhancementViewLevel]

export interface EnhancementViewLevelSelectorProps {
  selectedLevel: EnhancementViewLevel;
  onLevelChange: (level: EnhancementViewLevel) => void;
  disabled?: boolean;
}